import { CommonModule } from '@angular/common';
import { AppComponent } from '../app.component';
import { ComponentsRouteModule } from './components-routing.module';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { DashboardModule } from './dashboard/dashboard.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { NgxMaskPipe } from 'ngx-mask';
import { HomeModule } from './home/home.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TableTransactionsComponent } from './table-transactions/table-transactions.component';
import { TableTransactionsReservaComponent } from './table-transactions-reserva/table-transactions-reserva.component';

@NgModule({
  declarations: [TableTransactionsComponent, TableTransactionsReservaComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbModule,
    ComponentsRouteModule,
    MatPaginatorModule,
    MatTableModule,
    NgxMaskPipe,
    HomeModule,
    DashboardModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
  ],
  providers: [],
  exports: [TableTransactionsComponent, TableTransactionsReservaComponent],
  bootstrap: [AppComponent],
})
export class ComponentsModule {}
